import { useTranslation } from 'react-i18next';

import { StyledButton } from '@selfserve/react-ui';
import { apiEndpoints, buttonIds } from '@selfserve/react-utils';
import { useAuth } from '@selfserve/react-hooks';
import { useSubscriptionOverview } from '../context/subscription-overview-context';

interface AddPlanProps {
  isLink?: boolean;
}

export const AddPlan = ({ isLink }: AddPlanProps) => {
  const { t } = useTranslation();
  const { token } = useAuth();
  const subscriptionOverviewDataContext = useSubscriptionOverview();

  // Don't show add plan button if user has an avatar subscription
  const hasAvatarSubscription = subscriptionOverviewDataContext?.subscriptionOverviewData?.subscriptionInfoList?.some(
    (sub: any) => sub.planItem?.product_family === 'AVATAR_STUDIO'
  );

  if (hasAvatarSubscription) {
    return null;
  }

  return (
    <form
      id={buttonIds.overviewAddPlan}
      action={apiEndpoints.addPlan}
      method="post"
      target="_blank"
    >
      <input type="hidden" name="token" value={token} />
      <input type="hidden" name="path" value="upgrade" />
      <StyledButton
        id={buttonIds.overviewAddPlan}
        type="submit"
        isLink={isLink}
        withoutMargin
      >
        <span className="p-button-label">
          {t(`common.${isLink ? 'add-a-plan' : 'add-plan'}`)}
        </span>
      </StyledButton>
    </form>
  );
};
